import { Divider as MuiDivider, Grid } from "@mui/material";
import Box from "@mui/material/Box";
import { spacing } from "@mui/system";
import PropTypes from "prop-types";
import React, { useEffect } from "react";
import { connect } from "react-redux";
import styled from "styled-components";
import StandardHeader from "../../components/global/StandardHeader";
import { LeftSidebar } from "layout-blueprints";
import { get as getDevelopers } from "../../modules/developer/api/actions";
import { get as getProperties } from "../../modules/property/api/actions";
import PropertyTable from "../../modules/property/components/Table";
import { get as getPropertyManagers } from "../../modules/propertyManager/api/actions";
import { getAllPropertyStatuses } from "../../modules/apl/api/actions";
import { get as getOwners } from "../../modules/owner/api/actions";


const Divider = styled(MuiDivider)(spacing);
const PropertiesPage = (props) => {
  // On initial page load:
  useEffect(() => {
    props.getProperties(null, null);
    props.getDevelopers();
    props.getOwners();
    props.getPropertyManagers();
    props.getAllPropertyStatuses();
    document.title = "Ubil+ Properties Search";
  }, []);

  return (
    <LeftSidebar>
      <StandardHeader title="Properties Management" />
      <Divider className="mb-3 mt-3" />
      <Grid container spacing={0}>
        <Grid item xs={12} sm={12} md={12} lg={12} sx={{ width: '100%' }}>
          <PropertyTable />
        </Grid>
      </Grid>
    </LeftSidebar>
  );
};

PropertiesPage.propTypes = {
  user: PropTypes.object.isRequired,
  apl: PropTypes.object.isRequired,
  getProperties: PropTypes.object.isRequired,
  properties: PropTypes.object.isRequired,
  getDevelopers: PropTypes.func.isRequired,
  getOwners: PropTypes.func.isRequired,
  getPropertyManagers: PropTypes.func.isRequired,
  getAllPropertyStatuses: PropTypes.func.isRequired,
};

// Component State
function PropertiesPageState(state) {
  return {
    user: state.user,
    apl: state.apl,
    properties: state.properties,
  };
}

export default connect(PropertiesPageState, {
  getProperties,
  getDevelopers,
  getOwners,
  getPropertyManagers,
  getAllPropertyStatuses,
})(PropertiesPage);
